import { render, staticRenderFns } from "./ProductCardsStacked.vue?vue&type=template&id=bb4f2542&"
import script from "./ProductCardsStacked.vue?vue&type=script&lang=js&"
export * from "./ProductCardsStacked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports